import React, { Component } from "react";
import HttpUtil from "../../Util/httpUtil";
import Config from "../../Util/config";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Container } from "reactstrap";
import "../../_Content/css/modal-arquivos-recentes.css";

const idUsuario = localStorage.getItem("CodUsuario");

class ModalNotificacaoArquivosRecentes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: this.props.modal,
            isChecked: false
        };
    }

    closeModal = () => {
        if (this.state.isChecked) 
            this.requestData();
        
        this.setState({ modal: false });

        if (this.props.onClose)
            this.props.onClose();
    }

    onChangeCheckBox = () => {
        this.setState({
            isChecked: !this.state.isChecked
        });
    }

    requestData = () => {
        return new Promise((resolve, reject) => {
            let urlApi = `${Config.urls.API_URL_BASE}Acesso/NaoExibirNotificacaoArquivosRecentes/${idUsuario}`;
            HttpUtil.eco_GET(urlApi, (response) => {
                resolve({ resposta: response });
            }, () => { console.log("Error ExibirErrosEstrutura"); });
        }).then(res => {
            if (res.resposta)
                localStorage.setItem("ExibirNotificacaoArquivosRecentes", false);
        });
    };

    render() {
        return (
            <Modal id='modalFeedback' isOpen={this.state.modal} className={this.props.className}>
                <ModalBody>
                    <Container id="modal-notificacao">
                        <Row md={12}>
                            <Col md={4} className='col-sm-10 col'>
                                <i className='ecoico ecoico-calendar' />
                            </Col>
                            <Col md={8}>
                                <Row md={12}>
                                    <h2>Arquivos Recentes</h2>
                                </Row>
                                <Row md={12}>
                                    <span>
                                        <strong>“Arquivos recentes"</strong> apresenta todos os arquivos enviados nos últimos 2 dias. Nesse período as validações básicas e inteligentes podem ser ativadas e aplicadas nesses arquivos. Uma vez ativa uma das validações, os resultados deste serão salvos e ficarão sempre disponíveis.
                                    </span>
                                    <span>
                                        Após o período de 2 dias, os resultados com base nas validações realizadas serão gravados e ficarão disponíveis para consulta no <strong>“Histórico”</strong>, onde não será possível ativar novas validações, sendo necessário passar novamente o arquivo.
                                    </span>
                                    <span>
                                        Para a sua comodidade e segurança ficamos com seu arquivo apenas durante esse período. Após isso, apenas os resultados ficarão arquivados, conforme descrito no <strong>Termo de uso</strong>.
                                    </span>
                                </Row>
                            </Col>
                        </Row>
                        <Row md={12}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={this.state.isChecked}
                                    onChange={this.onChangeCheckBox}
                                    className="ecoforms error ml-3" />
                                <label>Não quero mais ver essa mensagem.</label>
                            </label>
                        </Row>
                        <Row md={12}>
                            <Col className="box-button">
                                <Button className='float-right btnFechar' outline color='primary' onClick={this.closeModal}>Fechar</Button>{' '}
                            </Col>
                        </Row>
                    </Container>
                </ModalBody>
            </Modal>
        );
    }
}

export default ModalNotificacaoArquivosRecentes;



// WEBPACK FOOTER //
// ./src/Componente/Arquivos/ModalNotificacaoArquivosRecentes.jsx